import { render, staticRenderFns } from "./personRecordDetail.vue?vue&type=template&id=2aefbd69&scoped=true"
import script from "./personRecordDetail.vue?vue&type=script&lang=js"
export * from "./personRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./personRecordDetail.vue?vue&type=style&index=0&id=2aefbd69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aefbd69",
  null
  
)

export default component.exports